import { afficherDecimal, arrondiNombre } from '@/helpers/utils'

export default function afficherArrondi(valeur) {
  return afficherDecimal(arrondiNombre(valeur, 3))
}
